<script lang="ts">
    import {getInjector} from 'src/core';
    import {Kind, SearchType} from 'shared/constants';
    import type {Rec, RecordSearchParams} from 'src/typings';
    import type {MentionSearchType} from './types';
    import {createEventDispatcher} from 'svelte';
    import {SearchManagerBuilderFactoryService} from 'src/features/search/search-manager/search-manager-factory.service';
    import {createFloatingActions} from 'svelte-floating-ui';
    import {floatingUiCommonSettings} from 'shared/utils/floating-ui-common-settings';
    import {MENTION_USER_FOND_ID} from 'src/features/threads/thread-content/composer/constants';
    import RecordSearchPopover from 'src/features/record/inline-record-search/RecordSearchPopover.svelte';

    export let query: string;
    export let searchType: MentionSearchType | null = null;

    const dispatch = createEventDispatcher<{'mention-select': Rec}>();
    const [floatingRef, floatingContent] = createFloatingActions(floatingUiCommonSettings('top-start'));

    const searchManager = getInjector().getByClass(SearchManagerBuilderFactoryService)
        .createBuilder<RecordSearchParams, Rec>()
        .withStaticParams({
            pageSize: 6,
            facetsEnabled: false,
            datasource: 'local',
            rootFond: searchType === 'user' ? [{id: MENTION_USER_FOND_ID}] : undefined,
            q: query,
            kind: [Kind.KIND_RECORD],
            type: SearchType.TYPE_SEARCH_SELECTION
        })
        .createLocalSearch(false);

    function search(q: string) {
        searchManager.newSearchWithPartialParams({q});
    }

    $: search(query);
</script>

<div class="mentions-popover-wrapper" use:floatingRef>
    <RecordSearchPopover onSelect={(rec) => dispatch('mention-select', rec)}
                         use={[floatingContent]}
                         {searchManager}
                         open/>
</div>

<style lang="less">
    .mentions-popover-wrapper {
        width: 100%;
    }
</style>
